module.exports = __webpack_public_path__ + "static/media/webpage-after.6210ec12.png";